import { Card } from 'reactstrap';
import { Header } from './parts/Header';
import ProcessList from './parts/ProcessList';
import { HeaderLoader } from './parts/HeaderLoader';
import { FormProvider, useForm } from 'react-hook-form';
import { ProcessListLoader } from './parts/ProcessListLoader';

export default function AcademicOffer() {
  const methods = useForm({
    defaultValues: {
      selectedAcademicOffer: null as { label: string; value: number } | null,
    },
  });

  const { watch } = methods;
  const selectedAcademicOffer = watch('selectedAcademicOffer');

  return (
    <HeaderLoader>
      <Card className="p-4">
        <FormProvider {...methods}>
          <Header />
        </FormProvider>
        {selectedAcademicOffer?.value && (
          <ProcessListLoader academicOfferId={selectedAcademicOffer.value}>
            <ProcessList />
          </ProcessListLoader>
        )}
      </Card>
    </HeaderLoader>
  );
}
